import styled from 'styled-components';
import Icon from '../../../../_shared/components/Icon';

export const Header = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  padding: 0px;
  background-color: ${({ theme }) => theme.COLORS.BASE};
`;

export const CloseIcon = styled(Icon).attrs({
  icon: 'TR5-Close_X'
})`
  width: 9px;
  height: 9px;
`;

export const CloseButton = styled.button`
  display: inherit;
  border: none;
  outline: none;
  cursor: pointer;
  background-color: ${({ theme }) => theme.COLORS.BASE};
  height: 28px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  line-height: ${({ theme }) => theme.FONT_SIZES.SMALL};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  text-transform: uppercase;
  padding: 0px;

  & > span {
    margin-right: 6px;
  }
`;

export const Title = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
  line-height: ${({ theme }) => theme.FONT_SIZES.LARGE};
  margin-top: 18px;
  margin-bottom: 8px;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledLineItem = styled.div`
  margin-top: 24px;
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  line-height: ${({ theme }) => theme.FONT_SIZES.BASE};
`;

export const StyledRowTitle = styled.div`
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  margin-bottom: 6px;
`;

export const StyledRowContent = styled.div`
  margin-bottom: 6px;

  & > div > p {
    margin: 3px;
  }
`;
